import { useState, useEffect } from 'react';
import { AiOutlineArrowLeft, AiOutlineArrowRight } from 'react-icons/ai';
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
// import { sliderData } from '../slider/slider-data';  
import axios from '../../../Utilities/axios';
import hotelplace from '../../../assets/hotelplace.webp';
import { getHotelImage } from '../../../assets/hotelImages';       
import './Slider.css';

const Slider = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [sliderData2, setSliderData2] = useState([]) 
  const [isLoading, setIsLoading] = useState(false)   
  // const [sliderIMG, setSetliderIMG] = useState()
  //  let sliderIMG = []
  const slideLength = sliderData2.length;

  const getHotelImages = async () =>{
    setIsLoading(true);
    const hotels = await axios.get(`/registrations/hotels?sourceType=showInCompanySite&hotelGroupName=Residency`);
    // console.log("hotels", hotels.data)
    setSliderData2(hotels.data)

    setIsLoading(false);
  }

  


  useEffect(()=>{
    getHotelImages()

  },[])
  

  
  const autoScroll = true;
  let slideInterval;
  let intervalTime = 8000;

  const nextSlide = () => {
    setCurrentSlide(currentSlide === slideLength - 1 ? 0 : currentSlide + 1);
  };

  const prevSlide = () => {
    setCurrentSlide(currentSlide === 0 ? slideLength - 1 : currentSlide - 1);
  };

  function auto() {
    slideInterval = setInterval(nextSlide, intervalTime);
  }

  useEffect(() => {
    setCurrentSlide(0);
  }, []);

  useEffect(() => {
    // eslint-disable-next-line
    if (autoScroll) {
      auto();
    }
    return () => clearInterval(slideInterval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentSlide]);

  return (
    <div className='slider'>
      {isLoading ? (
        <div
          className='room_type'
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div className='book_img'>
            <Skeleton height={700} width={700} />
          </div>
        </div>
      ) : (
        <>
          <AiOutlineArrowLeft className='arrow prev' onClick={prevSlide} />
          <AiOutlineArrowRight className='arrow next' onClick={nextSlide} />
          {sliderData2 && sliderData2.map((slide, index) => {
            return (
              <div
                className={index === currentSlide ? "slide current" : "slide"}
                key={index}
              >
                {index === currentSlide && (
                  <div>
                    <img src={slide.picture} onError={(e) => {
  const match = getHotelImage(slide.hotelName);
  if (match && e.target.src !== match) {
    e.target.src = match;
  } else {
    e.target.src = hotelplace;
  }
}} alt='slide' className='image' />
                    <div className='content'>
                      <h2>{slide.hotelName}</h2>
                      {/* <p>{slide.desc}</p> */}
                      <hr />
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </>
      )}
    </div>
  );
};

export default Slider;
